import type { VoidFunctionComponent } from 'react';

import { useOrganizationPackageLabels } from '../../../hooks/api/packageLabels';
import FilterCard from '../../generic/Filter/FilterCard';
import FormLabel from '../../generic/Forms/FormLabel';
import type { AnyFilter } from '../../../../shared/organizationPackages/filters';

import PackageLabelsFilter from './PackageLabelsFilter';

type PackageFiltersForVersionProps = {
  arePackageLabelsLoading: boolean;
  packageLabelOptions: string[];
  selectedPackageLabels: string[];
  setFilters: (...args: unknown[]) => void;
};

/**
 * PackageFiltersForVersion has contains all filters related to filtering projects for a given package version.
 * It currently includes package labels only.
 */
const PackageFiltersForVersion: VoidFunctionComponent<PackageFiltersForVersionProps> = ({
  arePackageLabelsLoading,
  packageLabelOptions,
  selectedPackageLabels,
  setFilters,
}) => (
  <FilterCard id="package-inventory-package-filters" title="Package">
    <FormLabel label="Labels">
      <PackageLabelsFilter
        isLoading={arePackageLabelsLoading}
        packageLabelOptions={packageLabelOptions}
        selectedPackageLabels={selectedPackageLabels}
        setFilters={setFilters}
      />
    </FormLabel>
  </FilterCard>
);

type PackageVersionFiltersPackagesContainerProps = {
  filters: AnyFilter;
  setFilters: (filters: AnyFilter) => void;
};

/**
 * Stateful container for the package filters for a given package version.
 */
export const PackageVersionFiltersPackagesContainer: VoidFunctionComponent<
  PackageVersionFiltersPackagesContainerProps
> = ({ filters, setFilters }) => {
  // Load org package labels with the useOrganizationPackageLabels hook.
  const { data: packageLabelsResponse, isLoading: arePackageLabelsLoading } = useOrganizationPackageLabels();
  const packageLabels = packageLabelsResponse?.packageLabels ?? [];
  const packageLabelOptions = packageLabels.map((packageLabel) => packageLabel.name);

  return (
    <PackageFiltersForVersion
      arePackageLabelsLoading={arePackageLabelsLoading}
      packageLabelOptions={packageLabelOptions}
      selectedPackageLabels={filters.packageLabels ?? []}
      setFilters={setFilters}
    />
  );
};
